const COMPANY_SLUG_KEY = 'companySlug'

export const FALLBACK_COMPANY_SLUG = 'company'

export const COMPANY_NAME_PARAM = ':companyName'

const CYRILLIC_TO_LATIN: Record<string, string> = {
  а: 'a', б: 'b', в: 'v', г: 'h', ґ: 'g', д: 'd', е: 'e', ё: 'e', є: 'ie',
  ж: 'zh', з: 'z', и: 'y', і: 'i', ї: 'i', й: 'i', к: 'k', л: 'l', м: 'm',
  н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'kh',
  ц: 'ts', ч: 'ch', ш: 'sh', щ: 'shch', ъ: '', ы: 'y', ь: '', э: 'e',
  ю: 'iu', я: 'ia',
}

const transliterate = (value: string): string =>
  Array.from(value)
    .map(char => CYRILLIC_TO_LATIN[char] ?? char)
    .join('')

export const slugifyCompany = (name: string): string =>
  transliterate(name.toLowerCase())
    .normalize('NFKD')
    .replace(/\p{M}/gu, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || FALLBACK_COMPANY_SLUG

export const getStoredCompanySlug = (): string =>
  localStorage.getItem(COMPANY_SLUG_KEY) || FALLBACK_COMPANY_SLUG

export const setStoredCompanySlug = (slug: string): void => {
  localStorage.setItem(COMPANY_SLUG_KEY, slug)
}

export const withCompany = (
  route: string,
  slug: string = getStoredCompanySlug(),
): string => route.replace(COMPANY_NAME_PARAM, slug)
